var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlashSolid = function SvgSlashSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#340AAB",
    fillRule: "evenodd",
    d: "M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10M4 11a7 7 0 0 1 7-7 7 7 0 1 1 0 14 7 7 0 0 1-7-7m2.436-3.804A5.9 5.9 0 0 0 5.046 11c0 3.255 2.65 5.923 5.954 5.923 1.454 0 2.78-.516 3.811-1.372zm.754-.748 8.375 8.355A5.9 5.9 0 0 0 16.955 11c0-3.255-2.65-5.923-5.955-5.923-1.453 0-2.78.516-3.81 1.371",
    clipRule: "evenodd"
  })));
};
export default SvgSlashSolid;